<template>
  <ion-page id="video-page">
    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
            :style="styleVideo">
        <VideoJs :height="videoHeight" :width="videoWidth" :name="props.videoName"
              :egg=true></VideoJs>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>

import { IonItem,IonInput,IonPage, IonContent , modalController } from '@ionic/vue';

  // https://videojs.com/getting-started

  import VideoJs from '@/components/VideoJs.vue'
  import { useGetData } from '@/composables/getData.js'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import { availableWidthHeight, isScreenPortraitOrientation} from '@/composables/screenSize'
  import { ref, watch } from 'vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { doStartupCheck } from '@/composables/startupCheck.js'

  const connectionStore = useConnectionStore()

  var availableSpace = availableWidthHeight(false)
  const videoHeight = ref(availableSpace.height-100)
  const videoWidth = ref(availableSpace.width)

  const isDark = ref(connectionStore.getDarkmode != "light")

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const props = defineProps({
    videoName : {
      type : String,
      default : "https://www.chessvis.com/videos/whoo.mp4"
    }
  })

  const styleVideo = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
  
     updateWidthHeights()
     watchVideo(props.videoName)
   }
 
   doStartupCheck(false,afterStartupCallbackRoutine)

   watch(() => windowSizeStore.getWindowSize, () => {
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    updateWidthHeights()
  })

  function updateStyleObjects(boundaries) {
    styleVideo.value.height = boundaries['video'].height + "px"
    styleVideo.value.width = boundaries['video'].width + "px"
    styleVideo.value.top = boundaries['video'].top + "px"
    styleVideo.value.left = boundaries['video'].left + "px"

    videoHeight.value = boundaries['video'].height-100
    videoWidth.value = boundaries['video'].width
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculateWidthHeights(availableSpace) :
                                      calculateWidthHeights(availableSpace)
    updateStyleObjects(boundaries)
  }

  function calculateWidthHeights(availableSpace) {

    const videoPositionTop = 0
    const videoPositionLeft = availableSpace.leftRightIndent
    const videoHeight = availableSpace.height - videoPositionTop
    const videoWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { video : {
        width : videoWidth,
        height : videoHeight,
        left : videoPositionLeft + availableSpace.leftIndent,
        top : videoPositionTop+ availableSpace.topIndent
      }

    }
    return (result)
  }

  function processWatchVideoJsonResponse(json) {
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
  }

  function watchVideo(videoName) {
    var formData = {
      v : videoName
    }
    useGetData("chessvis_watch_video.php", formData, processWatchVideoJsonResponse)
  }
</script>

<style scoped>

</style>